import React, {Component} from 'react';
import Category from './Category/Category';
import Spinner from '../Elements/Spinner/Spinner';
import './Navigation.css';
import {ajax} from '../../Context';

const AJAX_TYPE = '135797';

class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            category:[]
        };
    }

    componentDidMount() {
        fetch(ajax.url + '?type=' + AJAX_TYPE + '&uhash=' + this.props.hash)
            .then(response => response.json())
            .then(data => this.setState({data}));
    }

    render() {
        if(typeof this.state.data === 'undefined' || this.state.data === null || this.state.data.length === 0) {
            return <Spinner message="Die Produkte und Dokumente werden geladen, bitte haben Sie etwas Geduld. Der Vorgang kann einige Sekunden dauern." />;
        }
        return (
            <div className="Navigation">
                <ul className="first-level-tabs">
                    {this.state.data.map(function(item,index){
                        if(index === 0) {
                            if(this.props.rootCategory === 0) {
                                return <Category globalCategory={this.props.globalCategory} rootCategory={this.props.rootCategory} setRootCategory={this.props.setRootCategory} active="1" category={item} first='1' key={item.id} setCategory={this.props.setCategory} changeRoute={this.props.changeRoute} />;
                            }else{
                                return <Category globalCategory={this.props.globalCategory} rootCategory={this.props.rootCategory} setRootCategory={this.props.setRootCategory} category={item} first='1' key={item.id} setCategory={this.props.setCategory} changeRoute={this.props.changeRoute} />;
                            }
                        }else{
                            return <Category globalCategory={this.props.globalCategory} rootCategory={this.props.rootCategory} setRootCategory={this.props.setRootCategory} category={item} first='1' key={item.id} setCategory={this.props.setCategory} changeRoute={this.props.changeRoute} />;
                        }
                    }.bind(this)
                    )}
                </ul>
            </div>
        )
    }
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/Components/Navigation/Navigation.js